import {request} from '@/utils/http';

let bargainList = '/special/list';
let specialGoods = '/special/goods'

export function POST_BARGAINLIST(params){
  return request(bargainList,'post',params)
}
export function POST_SPECIALGOODS(params){
  return request(specialGoods,'post',params)
}


// WEBPACK FOOTER //
// ./src/api/bargain.api.js